module.exports = __webpack_public_path__ + "img/about_2015.f96ebe49.png";